import React from "react";
import "../styles/Profile.css";
import { Link } from "react-router-dom";

const Profile = () => {
  return (
    <div className="profile-container">
      <div className="banner">
        {/* Left: Image */}
        <div className="banner-image">
          <img src="/images/BachJohn.jpg" alt="Dr. John R. Bach" />
        </div>

        {/* Center: Basic Info */}
        <div className="banner-content">
          <h2>Dr. John R. Bach, MD</h2>
          <p>Professor</p>
          <p>Professor of Neurology</p>
          <p>Professor of Phys Med & Rehabil Rutgers University NJMS</p>
          <p>
            Medical Director, Center for Noninvasive Mech Ventilation,
            University Hospital
          </p>
          <p>Active Director, MDA Clinic of Rutgers University NJMS</p>
          <p style={{ paddingTop: "20px" }}>
            <Link
              to="https://njms.rutgers.edu/departments/physical_medicine_rehabilitation/index.php"
              style={{
                textDecoration: "none",
                color: "darkblue",
              }}
            >
              Department of Physical Medicine Rehabilitation
            </Link>
          </p>
        </div>

        {/* Right: Roles */}
        <div className="banner-content">
          <h2>Academics</h2>
          <p>Behavioral Health Science Building (BHSB)</p>
          <p>183 South Orange Avenue Room F1559</p>
          <p>Hours: 9am-5pm EST</p>
          <p>Phone: (973) 972-2809</p>
          <p>Fax: (973) 972-0918</p>
          <p style={{ paddingTop: "20px" }}>
            <Link
              to="https://njms-web.njms.rutgers.edu/profile/myProfile.php?mbmid=bachjr"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              Dr. Bach's academic profile
            </Link>
          </p>
        </div>
      </div>
      <div className="bib-container">
        <div className="bib-title">
          <h3>Biography</h3>
        </div>

        {/* Introduction Section */}
        <div className="center-container">
          <div className="bib-introduction">
            <p>
              Dr. John R. Bach received his medical degree from the College of
              Medicine and Dentistry of New Jersey in 1976, and completed
              residency training in Physical Medicine and Rehabilitation at New
              York University and Pediatrics in 1980. He is or has been a fellow
              of the Association of Academic Physiatrists, the American College
              of Chest Physicians, and a fellow of the American Academy of
              Physical Medicine and Rehabilitation. He has been on the faculty
              of the Rutgers University-New Jersey Medical School where he is a
              Professor of Physical Medicine and Rehabilitation, Vice Chairman
              of the Department of Physical Medicine and Rehabilitation,
              Professor of Neurology in the Department of Neurology, Director of
              Research and Associate Medical Director of the Department of
              Physical Medicine and Rehabilitation at University Hospital,
              Newark, N.J., Director of the Rutgers New Jersey Medical School
              Muscular Dystrophy Association Clinic all since 1983, and Medical
              Director of the Center for Ventilator Management Alternatives,
              University Hospital, Newark, N.J. since 1992.
            </p>
            <p>
              Dr. Bach has over 320 peer reviewed scientific articles, 200 book
              chapters, and 16 medical textbooks on neuromuscular and pulmonary
              medicine in English, Spanish, and Japanese and has lectured on
              these topics in over 60 countries. He has received many awards for
              excellence in research writing, and others include the UMDNJ
              University Excellence Award for Patient Care, and the Newark Beth
              Israel Health Care Foundation Humanism in Medicine. Bach pioneered
              up to continuous noninvasive ventilatory support (NVS)
              alternatives to tracheotomies and extubation and trach tube
              removals to NVS and is responsible for mechanical in-exsufflation
              (cough assistance) being back on the market since 1993.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
